module.exports = __webpack_public_path__ + "static/media/adult_icon.7ed69aed.svg";